import { render, staticRenderFns } from "./NewPass.vue?vue&type=template&id=5bcfc96c&"
import script from "./NewPass.vue?vue&type=script&lang=js&"
export * from "./NewPass.vue?vue&type=script&lang=js&"
import style0 from "./NewPass.vue?vue&type=style&index=0&id=5bcfc96c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports